<template>
    <div>
        <div class="show-navigation">
            <header class="header">
                <div class="container">
                    <div class="row align-items--center">
                        <div class="col-2">
                            <router-link to="/" class="btn btn--icon btn--white">
                                <i class="material-icons">keyboard_arrow_left</i>
                            </router-link>
                        </div>

                        <div class="col-8">
                            <h1 class="header__title">News feed</h1>
                        </div>
                    </div>
                </div>
            </header>
            <div class="container">
                <div class="col-12 avatar-wrapper-lg">
                    <NewsItem v-for="(item, key) in news"
                              v-bind:data="item"
                              v-bind:key="'news-' + key">
                    </NewsItem>
                </div>
            </div>
        </div>

        <navigation></navigation>
    </div>
</template>

<script>
    import AppHeader from "./partial/AppHeader";
    import Navigation from "./partial/Navigation";
    import api from "../api/news";
    import NewsItem from "./partial/NewsItem";

    export default {
        name: "NewsList",
        components: {
            AppHeader,
            NewsItem,
            Navigation
        },

        data: function () {
            return {
                news: null
            }
        },

        methods: {
            async loadNews() {
                try {
                    let response = await api.index()
                    this.news = response.data
                } catch (e) {
                    Quiz.$emit('news-load-error')
                }
            },
        },
        created() {
            this.loadNews();
        }
    }
</script>